<template>
  <div class="radiobutton" v-bind:class="{ disabled: isDisabled }">
  	<input type="radio" v-on:change="onChange()" v-bind:id="id"  v-bind:name="name" v-bind:value="value" v-bind:checked="checked" v-bind:disabled="isDisabled" />       
  	<label v-bind:class="[ischecked ? 'checked' : '']" v-bind:for="id">{{ id }}</label>
  </div>
</template>


<script>
  export default {
    name: 'radiobutton',
    props: ['id', 'name', 'value', 'action', 'checked', 'isDisabled'],
    mounted: function(){
      this.ischecked = this.checked
    },
    methods: {
    	onChange: function() {
		  	EventBus.$emit('action', {action: this.action, value: this.value})
    	}
    },
    data: function() {
      return {
        ischecked: false
      }
    }
  }
</script>


<style lang="scss" src="./style.scss"></style>



// WEBPACK FOOTER //
// RadioButton.vue?05375cad